import React from 'react';
import { omit } from 'ramda';

export const FormFieldError = ({ children }) => (
  <div className="form-field-error font-normal text-red-95 text-[12px] block my-[10px] mx-0">{children}</div>
);
